import React, { useRef, useMemo } from "react";
import flecha_s from "./assets/flecha-s.png";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./index.css";
import { removeHTML } from "../../utils";
import { useNavigate } from "react-router-dom";
import { DEFAULT_HEADER_DATA } from "../../utils/state";
import { useTheme } from "../../contexts/ThemeContext";
import { HeaderSkeleton } from "./skeleton";
import defaultBanner from "./assets/fotoportadalandingcursos.jpg";
/* import defaultBanner from "./assets/img-interior25.jpg"; */
import { useConfig } from "../../contexts/config";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { useAuth } from "../../contexts/AuthContext";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

/* to work on */
export const HeaderCourses = ({ moodle, lang }) => {
  const auth = useAuth();
  const theme = useTheme();
  let {config} = useConfig();
  const header = useRef(null);
  /*   const banner = React.useRef(null) */
  const [state, setState] = React.useState(() => {
    if (moodle.courses && moodle.courses.length > 0) {
      return {
        course: moodle.courses[0],
        text: removeHTML(moodle.courses[0].summary),
      };
    }
    return DEFAULT_HEADER_DATA;
  });
  const navigation = useNavigate();

  React.useEffect(() => {
    if (moodle.courses && moodle.courses.length > 0) {
      const firstCourse = moodle.courses[0];
      setState((prev) => {
        if (prev.course && prev.course.id === firstCourse.id) return prev;
        return {
          course: firstCourse,
          text: removeHTML(firstCourse.summary),
        };
      });
    }
  }, [moodle.courses]);

/*   React.useEffect(() => {
    if (moodle.courses && moodle.courses.length > 0) {
      if (header.current) {
        console.log(header.current)
        header.current.style.backgroundImage = `url(${defaultBanner})`;
         header.current.style.backgroundColor = "#9db1d1" : "#445269"; 
      }
       moodle
        .getBanner(moodle.courses[0].id)
        .then((banner) => {
          console.log(defaultBanner);
          
          // banner y color del banner se comenta y se lleva arriba el código para que no espere al getBanner y cambie de inmediato el color
          if (banner && header.current) { 
           
          } else if (!banner && header.current) {

          } 
          
        })
        .catch((err) => console.log(err)); 
    }
  }, [moodle.courses, theme.mode]); */

  /*   React.useEffect(() => {
    let item = moodle.courses[0];
    if (item?.overviewfiles?.length > 0) {
      let imgurl = moodle.getCourseImg(item);
      header.current.style.backgroundImage = `url(${imgurl})`;
    }
  }, []); */

  const handleNavigation = () => navigation(`/detailcourse/${state.course.id}`);

  const carouselBanners = useMemo(() => {
    return config?.carousel_banners ?? [
      {
        id: 0,
        image: "images/c3.jpg",
        button_text: "Ingresar",
        requiresCourse: true,
      },
      {
        id: 1,
        image: "images/c4.jpg",
        title: "Formación Cristiana con Excelencia Académica",
        text: "Formamos estudiantes capaces de discernir la verdad a la luz de las Escrituras, integrando fe y vida en cada asignatura.",
      },
      {
        id: 2,
        image: "images/c2.jpg",
        title: "La Familia como Núcleo Educativo",
        text: "Los padres son los principales responsables de la educación de sus hijos. En Ezer acompañamos a las familias en su labor formadora con herramientas prácticas y bíblicas.",
      },
    ];
  }, [config?.carousel_banners]);

  const useCarousel = carouselBanners && carouselBanners.length > 0;

  const visibleBanners = carouselBanners.filter((banner) => {
    if (auth?.user?.is_guardian && banner.requiresCourse) {
      return false;
    }

    return true;
  });

  return (
    <>
      {lang && (
        <div style={{ paddingTop: 80 }}>
          {useCarousel ? (
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={0}
              slidesPerView={1}
              navigation={false}
              loop={true}
              pagination={{ clickable: true }}
              autoplay={{ delay: 4500 }}
              speed={900}
              className="header-carousel"
              style={{
                "--swiper-pagination-bg-color": theme.colors.backgroundColorBannerBtn,
                "--swiper-pagination-txt-color": theme.mode === "light" ? "#16232c" : "#fff",
              }}
            >
              {visibleBanners.map((banner, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="header-banner"
                    style={{
                      backgroundImage: `url(${banner.image || defaultBanner})`,
                    }}
                  >
                    <div
                      className="header-banner-overlay"
                      style={{ backgroundColor: `${theme.colors.background_dark || '#0f233d'}cc` }}
                    >
                      {banner.requiresCourse && !state.course ? (
                        <>
                          <Skeleton baseColor="#cccccc" style={{ opacity: 0.5, width: "70%", height: "2.5rem", marginBottom: "1rem" }} />
                          <Skeleton baseColor="#cccccc" count={2} style={{ opacity: 0.5, width: "90%", height: "1.2rem", marginBottom: ".5rem" }} />
                          <Skeleton baseColor="#cccccc" style={{ opacity: 0.5, width: "30%", height: "3.5rem", marginTop: "1.5rem", borderRadius: "20px" }} />
                        </>
                      ) : (
                        <>
                          <h1 className="tit-principal font-bold" style={{ padding: 0, color: "#fff" }}>
                            {banner.requiresCourse ? state.course?.fullname : banner.title}
                          </h1>
                          <p className="text-generico-res" style={{ color: "#ddd", lineHeight: 1.6 }}>
                            {banner.requiresCourse ? state.text : banner.text}
                          </p>
                          {banner.button_text && (banner.button_link || (banner.requiresCourse && state.course)) && (
                            <button
                              type="button"
                              className="flex items-center self-center w-fit justify-center gap-2 py-4 px-16 rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
                              style={{ backgroundColor: theme.colors.backgroundColorBannerBtn, marginTop: 16 }}
                              onClick={() => {
                                const link = banner.requiresCourse ? `/detailcourse/${state.course.id}` : banner.button_link;
                                window.open(link, "_blank", "noopener,noreferrer");
                              }}
                            >
                              <span className="font-semibold" style={{ color: theme.colors.TextColorBannerBtn, fontSize: "1.8rem" }}>
                                {banner.button_text}
                              </span>
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div
              className="header-banner"
              ref={header}
              style={{
                backgroundImage: `url(${defaultBanner})`,
              }}
            >
              <div
                className="header-banner-overlay"
                style={{ backgroundColor: `${theme.colors.tertiary_light || '#0f233d'}cc` }}
              >
                {!state.course ? (
                  <HeaderSkeleton />
                ) : (
                  <>
                    <h1 className="tit-principal font-bold" style={{ padding: 0, color: "#fff" }}>
                      {state.course.fullname}
                    </h1>
                    <p className="text-generico-res" style={{ color: "#ddd", lineHeight: 1.6 }}>{state.text}</p>
                    <button
                      type="button"
                      className="flex items-center justify-center gap-2 py-3 px-8 rounded-full transition-transform duration-300 ease-in-out transform hover:scale-105"
                      style={{ backgroundColor: theme.colors.backgroundColorBannerBtn, marginTop: 16 }}
                      onClick={handleNavigation}
                    >
                      <span className="font-semibold" style={{ color: theme.colors.TextColorBannerBtn, fontSize: "1.1rem" }}>
                        {lang["Home"].course_btn}
                      </span>
                    </button>
                  </>
                )}
              </div>
            </div>
          )}

          {/* <header
            style={{
              padding: "20px 0",
              minHeight: 450,
              backgroundColor: theme.mode === "light" ? theme.colors.background_banner_light : theme.colors.background_banner_dark,
              backgroundBlendMode: "multiply",
              backgroundImage: `url(https://www.tipddy.cl/wp-content/uploads/2026/02/Gemini_Generated_Image_3e93yd3e93yd3e93-1-1-e1772819507199.jpg)`
            }}
            ref={header}
          >
            <div className="container mar">
              <div className="col-md-12">
                <div className="row">
                  {!state.course ? (
                    <HeaderSkeleton />
                  ) : (
                    <>
                      <div className="col-md-8">
                        <h1 className="tit-principal font-outfit font-semibold bg-slate-500/20 p-2 rounded-t-md backdrop-brightness-75 w-fit" style={{ padding: 0 }}>
                          {state.course.fullname}
                        </h1>
                        <p className="text-generico"></p>
                        <p className="text-generico-res bg-slate-500/20 rounded-b-md backdrop-brightness-75 w-fit">{state.text}</p>
                        <p className="text-generico-res">
                          <button
                            type="button"
                            className="flex items-center justify-center w-2/4 tablet:w-1/4 gap-2 py-2 px-4 rounded-lg transition-transform duration-300 ease-in-out transform hover:scale-105"
                            // style={theme.styles.darkmodebtn}
                            style={{ backgroundColor: theme.colors.backgroundColorBannerBtn }}
                            onClick={handleNavigation}
                          > */}
                            {/* <img src={flecha_s} alt="..." className="" /> */}
                            {/* <span
                              className="font-semibold"
                              style={{ color: theme.colors.TextColorBannerBtn }}
                            >
                              {lang["Home"].course_btn}
                            </span>
                          </button>
                        </p>
                      </div>
                    </>
                  )}
                  <div className="col-md-4 pos-img"></div>
                </div>
              </div>
            </div>
          </header> */}
        </div>
      )}
    </>
  );
};
